import { getToken } from '@/utils/auth'
/*
 * session.js
 * sessionstorage的实现
 */
function getItem(key) {
  const item = sessionStorage.getItem(getToken() + key)
  // 这点要判断是字符串还是对象
  const result = /^[{\[].*[}\]]$/g.test(item)
  if (result) {
    return JSON.parse(item)
  } else {
    return item
  }
}
function setItem(key, value) {
  // 这点要判断是字符串还是对象
  if (typeof value === 'string') {
    sessionStorage.setItem(getToken() + key, value)
  } else {
    const item = JSON.stringify(value)
    sessionStorage.setItem(getToken() + key, item)
  }
}
function removeItem(key) {
  sessionStorage.removeItem(getToken() + key)
}

function clear() {
  sessionStorage.clear()
}

const Session = {
  setItem,
  getItem,
  removeItem,
  clear
}
export default Session
